export function validZipCode(field) {
    const zipcode =
        /^(\d{5}(-\d{4})?|[A-CEGHJ-NPRSTVXY]\d[A-CEGHJ-NPRSTV-Z] ?\d[A-CEGHJ-NPRSTV-Z]\d)$/;
    return zipcode.test(field.value) ? true : false;
}
